import { MigrationManifest } from 'redux-persist'
import createMigrate from 'redux-persist/es/createMigrate'
import persistReducer from 'redux-persist/es/persistReducer'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

import data from './data'
import { userSettingsMigrations } from './migrations/migrations'

const persistConfig = {
  key: 'userSettings',
  storage,
  version: 3,
  migrate: createMigrate(userSettingsMigrations as unknown as MigrationManifest, { debug: false }),
  blacklist: ['communications'],
}

export const reducer = persistReducer(persistConfig, data)
